import Select from "react-select";
import "./style.scss";

function Dropdown(props) {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
      border: state.isFocused ? "1px solid #0080ff" : "1px solid #ccc",
      borderRadius: 5,
      cursor: "pointer",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#012970"
        : state.isFocused
        ? "#e0e0e0"
        : "white",
      color: state.isSelected ? "white" : "black",
      cursor: "pointer",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "white" : "black",
    }),
  };

  return (
    <Select
      options={props.options}
      styles={customStyles}
      placeholder=""
      value={props.value}
      isSearchable={false}
      isDisabled={props.disabled}
      onChange={(selectedOption) => props.onSelect(selectedOption)}
    />
  );
}

export default Dropdown;
